/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { clearUserData } from './common';
import request from './request';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const sendError = async (error: string, stack: string) => {
  // only send errors in prod
  if (window.location.origin === 'https://bid2board.com') {
    const user = JSON.parse(localStorage.getItem('user'));
    const userId = localStorage.getItem('userId');

    await request(`mutation {
      addError(
        stack: """${stack}""",
        message: "${error}",
        userId: "${userId}",
        url: "${window.location.href}",
        companyName: "${user?.companyName}"
      ) {
        status
      }
    }`);

    // clear storage in case invalid info were saved
    clearUserData();
  }
};

export default sendError;
